import state from './state'

export default {
    getVendorProducts() {
      return state.vendorProducts;
    },
  
    getTotalPages() {
      return state.totalPage;
    },

    getTotal() {
      return state.totalItems;
    },
    
    getCurrentVendorProduct() {
      return state.vendorProduct;
    }
  
};